import {
  apiAxios,
  apiExternalV1Axios,
  apiRequestInterceptor,
  apiResponseInterceptor,
  apiErrorHandler
} from '/@/modules/core/app/helpers/AxiosHelper';

apiAxios.interceptors.response.use(apiResponseInterceptor, apiErrorHandler);
apiAxios.interceptors.request.use(apiRequestInterceptor, apiErrorHandler);

apiExternalV1Axios.interceptors.response.use(apiResponseInterceptor, apiErrorHandler);
apiExternalV1Axios.interceptors.request.use(apiRequestInterceptor, apiErrorHandler);
